var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSkipped = function SvgSkipped(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 7"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.482 6.38C.226 6.38 0 6.182 0 5.802v-4.61C0 .813.226.617.482.617.618.617.74.67.871.745l3.874 2.276c.162.098.256.208.294.34V1.193c0-.38.226-.576.486-.576.136 0 .256.053.385.128l3.874 2.276c.162.098.26.208.298.34V.948q0-.45.444-.448h.837c.298 0 .445.136.445.448v5.107c0 .302-.147.445-.445.445h-.837c-.297 0-.444-.143-.444-.445v-2.42c-.038.133-.136.242-.298.34L5.91 6.25a.7.7 0 0 1-.385.128c-.26 0-.486-.196-.486-.576V3.636c-.038.132-.136.24-.294.339L.871 6.25a.73.73 0 0 1-.389.128"
  })));
};
export default SvgSkipped;